import React, { useRef, useState } from "react";
import "./styles.scss";
import { Popover } from "react-tiny-popover";
import cs from "classnames";
import { ReactComponent as DropdownIcon } from "../../../assets/Icon/dropdown.svg";
import useOnClickOutside from "../../../hooks/useOnClickOutside";
import OptionList from "./OptionList";
import { useSelector } from "react-redux";
import { themModeSelector } from "../../../redux/selectors/AuthSelectors";

interface DropdownProps {
  label?: string;
  onChange?: (any) => void;
  options?: any;
  value?: any;
  optionVal?: any;
  disabled: boolean;
}

const Dropdown: React.FC<DropdownProps> = ({
  label,
  options,
  value,
  onChange,
  optionVal,
  disabled,
}) => {
  const [show, setShow] = useState<boolean>(false);
  const [width, setWidth] = useState(0);
  const isOtherPopoverOpen = useRef();
  const { isDarkMode } = useSelector(themModeSelector);
  console.log("isDarkMode", isDarkMode);
  const [labelVal, setLabelVal] = useState<any>({
    label: label,
    value: "label---val",
  });
  const optionRef = useRef<any>();
  const handleOptions = () => {
    if (!disabled) {
      setShow(!show);
    }
  };

  useOnClickOutside(optionRef, () => {
    if (!isOtherPopoverOpen?.current) handleOptions();
  });
  const handleClick = (val) => () => {
    if (!val.subOption) {
      setLabelVal(val);
      onChange && onChange(val);
      handleOptions();
    }
  };

  const handleSubOptionClick = (val, sub_val) => {
    setLabelVal({ ...val, subOptionVal: { ...sub_val } });
    onChange && onChange({ ...val, subOptionVal: { ...sub_val } });
    handleOptions();
  };

  return (
    <div className="dropdown-select-wrapper">
      <Popover
        isOpen={show}
        align="start"
        positions={["bottom", "top"]} // preferred positions by priority
        content={
          <div className="dropdown-list-wrapper-border">
            <div
              className={cs("dropdown-list-wrapper", {
                ["isDarkMode"]: isDarkMode,
              })}
              style={{ width }}
              ref={optionRef}
            >
              <ul>
                {value && (
                  <li className={cs("select-option is-placeholder")}>
                    <span>{label}</span>
                  </li>
                )}
                {options.map((o, i) => (
                  <>
                    {o.subOption ? (
                      <OptionList
                        opt={o}
                        handleSubOptionClick={handleSubOptionClick}
                        optionVal={optionVal}
                        key={`${i}--subOption`}
                        index={i}
                        value={value}
                        labelVal={labelVal}
                        handleClick={handleClick}
                        isOtherPopoverOpe={isOtherPopoverOpen}
                      />
                    ) : (
                      <li
                        key={`${i}--option`}
                        className={cs("select-option", {
                          ["selected-option-active"]: value
                            ? value === o.value
                            : labelVal.value === o.value,
                        })}
                        onClick={handleClick(o)}
                      >
                        <span>{o.label}</span>
                      </li>
                    )}
                  </>
                ))}
              </ul>
            </div>
          </div>
        }
      >
        <div
          className={cs("select-option selected-option", {
            ["is-placeholder"]: disabled,
            ["isOpen"]: show,
          })}
          onClick={(e) => {
            setWidth(e?.currentTarget.offsetWidth);
            handleOptions();
          }}
        >
          <span>{value ? value : labelVal.label}</span>
          <DropdownIcon className="icon-dropdown" />
        </div>
      </Popover>
    </div>
  );
};
export default Dropdown;
